import React from "react";

const TimeContext = React.createContext();

export default TimeContext;